import React, { useEffect } from "react";
import { FormGroup, InputGroup, Card, Button, Dialog } from "@blueprintjs/core";
import { Trans, withTranslation } from "react-i18next";
import jwt from 'jwt-decode'

import {
  bonitickAuthenticatedPostFetchWithResult
}
  from "../../utils/BonitickAuthenticatedFetch";
import { useNavigate } from "react-router-dom";

export function CheckAuth() {
  const navigate = useNavigate();

  useEffect(() => {
    const tk = localStorage.getItem('token');
    try {
      jwt(tk);
    }
    catch (e) {
      navigate("/signin");
    }
  }, [navigate]);

  return null;
}

export function authHeader() {
  const tk = localStorage.getItem('token');
  if (tk) {
    return { Authorization: `Bearer ${tk}` };
  }
  else
    return {};
}

export function getLoggedUser() {
  const tk = localStorage.getItem('token');
  try {
    const user = jwt(tk)['user'];
    return user;
  }
  catch (e) {
    return '';
  }
}

export function getLoggedUserLevel() {
  const tk = localStorage.getItem('token');
  try {
    const level = jwt(tk)['level'];
    return level + 1; //level is not used now, just use perm_*, level > 0 is enough to navigate, and access button are displayed depending on perm_*
  }
  catch (e) {
    return 0;
  }
}

class BonitickConnection extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      btnLoading: false,
      stepToTp: false,
      errorCode: 0,
      qrCodeUrl: "",
    };

    this.pwd = undefined;
    this.login = undefined;

    this.submitAuth = this.submitAuth.bind(this);
  };

  isButtonValid() {
    return this.login === undefined
      && this.login.target.value.length < 3
      && this.pwd === undefined
      && this.pwd.target.value.length;
  }

  async submitAuth() {
    this.setState({ btnLoading: true });
    if (this.login === undefined || this.login.target.value.length < 3) {
      this.setState({ errorCode: 1, btnLoading: false });
    }
    else if (this.pwd === undefined || this.pwd.target.value.length < 3) {
      this.setState({ errorCode: 2, btnLoading: false });
    }
    else {
      bonitickAuthenticatedPostFetchWithResult('/bonification/loginAdmin', { user: this.login.target.value, pwd: this.pwd.target.value },
        async (code, authResponse) => {

          if (code === 200 && authResponse !== undefined && authResponse.token !== undefined) {
            this.setState({ stepToTp: true, btnLoading: false, qrCodeUrl: authResponse.qrcodeUrl });
          } else {
            this.setState({ errorCode: 3, btnLoading: false });
          }
        },
        () => { // bad auth or server unavailable
          this.setState({ errorCode: 3, btnLoading: false });
        }
      );
    }
  }

  async submitToTp() {
    this.setState({ btnLoading: true });
    bonitickAuthenticatedPostFetchWithResult("/bonification/loginTotp", { code: this.login.target.value },
      async (code, authResponse) => {
        if (code === 200 && authResponse !== undefined && authResponse.token !== undefined) {
          this.setState({ stepToTp: true, btnLoading: false });
          this.props.result(true);
        }
        else
          this.setState({ errorCode: 3, btnLoading: false });

      },
      () => { // bad auth or server unavailable
        this.setState({ errorCode: 3, btnLoading: false });
      });
  }

  render() {
    return (
      <div style={{ "paddingTop": "8%", "position": "absolute", "right": "50%" }}>
        <Card style={{ "maxWidth": "600 px" }}>
          {this.state.stepToTp &&
            <form onSubmit={e => {
              e.preventDefault(); // to avoid reload of the page on submit
              this.submitToTp();
            }}>
              <FormGroup label={<Trans>code</Trans>} labelFor="login-input">
                <InputGroup id="login-input" onChange={(login) => this.login = login} autoFocus={true} />
              </FormGroup>
              <Button type="submit" text={<Trans>submit</Trans>} loading={this.state.btnLoading} active={this.isButtonValid()} />
            </form>
          }
          {!this.state.stepToTp &&
            <form onSubmit={e => {
              e.preventDefault(); // to avoid reload of the page on submit
              this.submitAuth();
            }}>
              <FormGroup label={<Trans>login</Trans>} labelFor="login-input">
                <InputGroup id="login-input" onChange={(login) => this.login = login} autoFocus={true} />
              </FormGroup>
              <FormGroup label={<Trans>password</Trans>} labelFor="password-input">
                <InputGroup id="password-input" type="password" onChange={(pwd) => this.pwd = pwd} />
              </FormGroup>
              <Button type="submit" text={<Trans>submit</Trans>} loading={this.state.btnLoading} />
            </form>
          }
        </Card>
        {this.state.qrCodeUrl &&
          <Card style={{ "maxWidth": "600 px" }}>
            <Trans>Hello, this is your first login! Please scan this QRCode to Initialize your Multi Factor Authentication Application like "Google Authenticator" or "Microshoft Authenticator".</Trans>
            <img
              src={this.state.qrCodeUrl}
              style={{ maxWidth: "100%" }}
              alt="MFA qr code"
            />
          </Card>}
        <Dialog
          icon="error"
          title={<Trans>authentication error</Trans>}
          style={{ transition: 'none' }}
          canEscapeKeyClose={true}
          canOutsideClickClose={true}
          isOpen={this.state.errorCode > 0}
          onClose={() => {
            this.setState({
              errorCode: 0,
              btnLoading: false
            })
          }}>
          <div>
            {this.state.errorCode === 3 &&
              <>
                <p><Trans>the given login/password did not allow you to access this website</Trans></p>
                <p><Trans>check your credentials</Trans></p>
              </>
            }
            {(this.state.errorCode === 1 || this.state.errorCode === 2) &&
              <>
                <p><Trans>Control the syntax of your credentials</Trans></p>
              </>
            }
          </div>
        </Dialog>
      </div>
    );
  }
}

export default withTranslation()(BonitickConnection)
